import { useState, useCallback, useEffect } from 'react';
import { EosContextView } from '../../../../models/payroll';
import { GetEosContext } from '../../../../api/Payroll/payroll';

export function useEosContext(userId: string) {
  const [context, setContext] = useState<EosContextView | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await GetEosContext(userId);
      if (result.errors && result.errors.length > 0) {
        setError(result.errors[0]?.description ?? 'Unknown error');
        setContext(null);
      } else {
        setContext(result.payload);
      }
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to load EOS context');
      setContext(null);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { context, loading, error, refetch };
}
